import React from 'react'
import PageWrapper from '../components/PageWrapper'
import { Row, Col, Container, Carousel, Card, Button } from 'react-bootstrap'

import Mainstream from '../components/Buckets/Mainstream'
import Alternative from '../components/Buckets/Alternative'
import Speculative from '../components/Buckets/Speculative'


// import Ratio from 'react-bootstrap/Ratio'

const News = () => {
    return (
        <>
            <PageWrapper
                headerConfig={{
                    align: 'right',
                    button: 'account', // cta, account, null
                }}
            >

                <div >
                    {/* <Ratio aspectRatio="16x9"> */}
                    <Container>
                        <Row className="justify-content-center mt-md-6 pt-24 pt-lg-29">
                            <Col lg="9" xl="8">
                                <div className="px-md-12 text-center mb-11 mb-lg-14">
                                    <h2 className="title gr-text-2 mb-9 mb-lg-12">Our story</h2>
                                    <p className="gr-text-8 mb-0">
                                        With lots of unique blocks, you can easily build a page
                                        without coding. Build your next consultancy website within
                                        few minutes.
                                    </p>
                                </div>
                            </Col>
                            <Col xs="12">
                                <div 
                                    className="px-md-12 text-center mb-11 mb-lg-14" 
                                    css={`
                                            position: relative;
                                            padding-bottom: 56.25%;
                                            padding-top: 25px;
                                            height: 0;
                                    `}
                                >
                                    {/* <img src={imgBanner} alt="" className="w-100" /> */}
                                    <iframe
                                        // className="absolute"
                                        css={`
                                            position: absolute;
                                            top: 0;
                                            left: 0;
                                            width: 100%;
                                            height: 100%;
                                            
                                        `}
                                        width="560"
                                        height="315"
                                        src="https://www.youtube.com/embed/KZ3FowmUaY4"
                                        title="YouTube video player"
                                        frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen
                                    />
                                </div>

                            </Col>
                            {/* First bucket description */}
                            <Col lg="9" xl="8">
                                <div className="px-md-12 text-center mb-11 mb-lg-14">
                                    <h2 className="title gr-text-2 mb-9 mb-lg-12">Mainstream Media Narrative</h2>
                                    <p className="gr-text-8 mb-0">
                                        With lots of unique blocks, you can easily build a page
                                        without coding. Build your next consultancy website within
                                        few minutes.
                                    </p>
                                </div>
                            </Col>
                            <Mainstream />
                            {/* Second Bucket Description */}
                            <Col lg="9" xl="8">
                                <div className="px-md-12 text-center mb-11 mb-lg-14">
                                    <h2 className="title gr-text-2 mb-9 mb-lg-12">Alternative Media Narrative</h2>
                                    <p className="gr-text-8 mb-0">
                                        With lots of unique blocks, you can easily build a page
                                        without coding. Build your next consultancy website within
                                        few minutes.
                                    </p>
                                </div>
                            </Col>
                            <Alternative />
                            {/* Third Bucket Description */}
                            <Col lg="9" xl="8">
                                <div className="px-md-12 text-center mb-11 mb-lg-14">
                                    <h2 className="title gr-text-2 mb-9 mb-lg-12">Speculative Media Narrative</h2>
                                    <p className="gr-text-8 mb-0">
                                        With lots of unique blocks, you can easily build a page
                                        without coding. Build your next consultancy website within
                                        few minutes.
                                    </p>
                                </div>
                            </Col>
                            <Speculative />
                        </Row>

                    </Container>
                    {/* </Ratio> */}
                </div>
            </PageWrapper>
        </>
    )
}

export default News